// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"25bc3da9","518":"4f387a25","689":"2f1a12dc","702":"600fcfdb","956":"538853b7"}[chunkId] + ".chunk.js";
};